// libs
import styled, { css } from 'styled-components'
// themes
import { colors } from 'themes'
// icons
import UndoIcon from '@mui/icons-material/Undo'
import DotsIconOrigin from '@mui/icons-material/MoreHorizOutlined'
import EditIconOrigin from '@mui/icons-material/Edit'
import TrashIconOrigin from '@mui/icons-material/Delete'
// utils
import { size } from 'polished'

const Wrapper = styled('div')<{ isHovered: boolean }>`
  align-items: center;
  background-color: ${colors.gray190};
  border-radius: 4px;
  border: ${({ isHovered }) => (isHovered ? `2px solid ${colors.blue500}` : 'unset')};
  cursor: pointer;
  display: flex;
  height: 50px;
  margin-top: 8px;
  padding: 8px;
  position: relative;

  svg {
    margin: 0 8px;
  }
`

const IconWrapper = styled('div')`
  align-items: center;
  background-color: ${colors.blue500};
  border-radius: 4px 0 0 4px;
  display: flex;
  height: inherit;
  margin-left: -28px;
`

const PropertyTitle = styled('div')<{ isActive: boolean }>`
  align-items: center;
  display: flex;
  width: 100%;

  > svg {
    min-height: 20px;
    min-width: 20px;
  }

  ${({ isActive }) => !isActive && `color: ${colors.gray350}`};
`

const DotsIcon = styled(DotsIconOrigin)`
  transform: rotate(90deg);
  ${size('14px')};
`

const EditIcon = styled(EditIconOrigin)`
  margin: 0 !important;
  ${size('16px')};

  path {
    fill: ${colors.blue500};
  }
`

const TrashIcon = styled(TrashIconOrigin)<{ $color?: string }>`
  margin: 0 !important;
  ${size('16px')};

  path {
    fill: ${({ $color }) => $color || colors.blue500};
  }
`

const ButtonsWrapper = styled('div')`
  background-color: ${colors.white100};
  border-radius: 25px;
  border: 1px solid ${colors.blue500};
  display: flex;
  height: 24px;
  justify-content: space-around;
  position: absolute;
  right: 6px;
  top: -8px;
  width: fit-content;
  min-width: 38px !important;
  z-index: 1;
  padding: 0 2px;

  > div:not(:last-child) {
    border-right: 1px solid ${colors.blue500};
  }

  > div {
    padding: 0 2px;
    min-width: 24px;
  }
`

const Button = styled.div<{ disabled?: boolean }>`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;

  ${({ disabled }) =>
    disabled
      ? css`
          pointer-events: none;
          cursor: default;

          svg {
            path {
              fill: ${colors.gray320};
            }
          }
        `
      : css`
          cursor: pointer;

          &:hover {
            opacity: 0.7;
          }
        `}
`

const UnarchiveIcon = styled(UndoIcon)`
  && {
    ${size('16px')};

    path {
      fill: ${colors.blue500};
    }
  }
`

export { ButtonsWrapper, Button, DotsIcon, EditIcon, IconWrapper, PropertyTitle, TrashIcon, Wrapper, UnarchiveIcon }
